<template>
    <div>
        <div class="show-navigation">
            <header class="header">
                <div class="container">
                    <div class="row align-items--center">
                        <div class="col-2">
                            <a @click.prevent="handleBack('/')" class="btn btn--icon btn--white">
                                <i class="material-icons">keyboard_arrow_left</i>
                            </a>
                        </div>

                        <div class="col-8">
                            <h1 class="header__title">Achievements</h1>
                        </div>
                    </div>
                </div>
            </header>

            <div class="container" v-if="achievementGroup">
                <div class="tournament-box bdrs--sm-top" style="background-image: url(/img/pictures/forest.jpg);">
                    <img class="tournament-box__bg" src="/img/pictures/forest.jpg" alt="" />

                    <div class="tournament-box__content">
                        <h4 class="tournament-box__title">{{ achievementGroup.name }}</h4>
                        <span>{{ achievementGroup.description }}</span>
                    </div>
                </div>

                <div class="panel bg--layer-light bdrs--sm-bottom">
                    <ul class="list-unstyled mb--20">
                        <li class="mb--md" v-for="achievement in achievements">
                            <a :href="achievement.article_url" :class="{'info-item': true, 'info-item--disabled': hasUnlocked(achievement.id)}">
                                <span class="info-item__icon btn btn--icon btn--white"><img :src="achievement.image" alt="" /></span>
                                <span class="info-item__text">{{ achievement.name }}</span>
                                <span class="info-item__status info-item__status--green" v-if="hasUnlocked(achievement.id)"><i class="material-icons">done</i></span>
                                <span class="info-item__status" v-else @click="openModal(achievement.id)">?</span>
                            </a>
                        </li>
                    </ul>

                    <div class="progress mb--lg">
                      <div class="progress__bar"><span :style="achievementProgressbar"></span></div>
                        <span class="progress__name">{{ userAchievements.length }}/{{ achievements.length }} Completed</span>
                    </div>

                    <p v-if="achievementGroup.id === 1" class="text--center opacity--md"><strong>Group reward</strong></p>

                    <a v-if="achievementGroup.id === 1" class="btn btn--action btn--beam btn--yellow text--sm" href="/profile">
                        Profile customization

                        <div class="btn--action__icon btn--action__icon--normal btn--action__icon--left ml--10">
                            <img src="img/icons/trophy.svg" alt="" />
                        </div>
                        <div class="btn--action__icon btn--action__icon--normal btn--action__icon--right">
                            <img src="img/icons/lock.svg" alt="" />
                        </div>
                    </a>

                    <div v-if="achievementGroup.id === 1" class="panel bg--layer-light text--sm">
                        <p class="mb--0">You can change your avatar and your profile colour if you complete all of the achievements.</p>
                    </div>
                </div>

                <modal v-bind:key="achievement.id" :ref="'achievement' + achievement.id" :header-icon="achievement.image" show="false" type="success" v-for="achievement in achievements">
                    <template v-slot:title>
                        {{ achievement.name }}
                    </template>

                    <template v-slot:message>
                        <div v-for="reward in achievement.rewards">{{ reward }}</div>
                        <div v-html="achievement.description"></div>
                    </template>

                    <template v-slot:buttons><span></span></template>
                </modal>
            </div>
        </div>

        <navigation></navigation>
    </div>
</template>

<script>
    import Navigation from "./partial/Navigation";
    import dashboardApi from "../api/dashboard";
    import {mapGetters} from "vuex";
    import internalBackRoute from "../mixins/internalBackRoute";

    export default {
        name: "Achievements",
        mixins: [internalBackRoute],

        components: {Navigation},

        props: {
            group_id: {
                required: true
            }
        },

        data: function () {
            return {
                achievements: [],
                achievementGroup: null,
                userAchievements: [],
            }
        },

        methods: {
            async loadAchievements() {
                try {
                    let response = await dashboardApi.loadAchievements(this.group_id)

                    this.achievements = response.data.achievements
                    this.achievementGroup = response.data.achievementGroup
                    this.userAchievements = response.data.user_achievements
                } catch (e) {

                }
            },

            hasUnlocked(id) {
                if (!this.userAchievements) {
                    return false
                }

                return this.userAchievements.filter((item) => item.id == id).length
            },

            openModal(id) {
                this.$refs['achievement' + id][0].open()
            }
        },

        computed: {
            ...mapGetters('auth', [
                'user',
            ]),

            achievementProgressbar() {
                return 'width: ' + Math.round((this.userAchievements.length / this.achievements.length) * 100) + '%;'
            }
        },

        created() {
            this.loadAchievements()
        }
    }
</script>